import React from "react";
import { getProfileImageUrl } from "helpers/Image.helper";
import { getFlagByCountryCode, getCurrentLangName, getStudentName } from "helpers/String.helper";
import LoadingComponent from "commons/loading/Loading.component";

interface ApplyingRequestPopupProps {
    isInit: boolean;
    info: any;
    onClose: () => void;
    onReject: () => void;
    onAccept: () => void;
    onDetailInfo: () => void;
    errorMessage?: string;
}

const ApplyingRequestPopup: React.FC<ApplyingRequestPopupProps> = ({
    isInit,
    info,
    onClose,
    onReject,
    onAccept,
    onDetailInfo,
    errorMessage
}) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-screen h-screen top-0 left-0 p-4 !m-0">
            <div className="bg-white rounded-2xl p-6 w-full max-w-2xl mx-auto">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-gray-900">가입 요청</h3>
                    <button
                        type="button"
                        className="text-gray-400 hover:text-gray-600"
                        onClick={onClose}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {isInit ? (
                    <>
                        {info &&
                            <div className="flex flex-col items-center">
                                <div className="w-32 h-32 rounded-full overflow-hidden mb-4">
                                    <img
                                        src={getProfileImageUrl(info.userStudent.profileImage, 200)}
                                        alt="프로필 이미지"
                                        className="w-full h-full object-cover"
                                    />
                                </div>

                                <div className="text-center mb-4">
                                    <h4 className="text-xl font-bold mb-2">
                                        {getStudentName(info?.userStudent)}
                                    </h4>
                                    <p className="text-gray-600 mb-2">
                                        {info.userStudent.genderTypeCode === 'genderType:boy' ? '남성' : 
                                         info.userStudent.genderTypeCode === 'genderType:girl' ? '여성' : '성별 정보 없음'}
                                    </p>
                                    <div className="flex items-center justify-center gap-2">
                                        <span className="text-2xl">
                                            {getFlagByCountryCode(info.userStudent.countryCode)}
                                        </span>
                                        <span className="text-gray-700">
                                            {getCurrentLangName(info.userStudent.country?.names)}
                                        </span>
                                    </div>
                                    {info.userStudent.birthday && (
                                        <p className="text-gray-600 mt-2">
                                            {new Date().getFullYear() - new Date(info.userStudent.birthday).getFullYear()}세
                                        </p>
                                    )}
                                </div>

                                <div className="flex gap-4 w-full">
                                    <button
                                        onClick={onReject}
                                        className="w-full px-4 py-3 text-sm font-medium text-white bg-red-500 rounded-xl
                                    hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500/20
                                    transition-colors">
                                        거절
                                    </button>
                                    <button
                                        onClick={onAccept}
                                        className="w-full px-4 py-3 text-sm font-medium text-white bg-[#CF3688] rounded-xl
                                    hover:bg-[#B82F77] focus:outline-none focus:ring-2 focus:ring-[#CF3688]/20
                                    transition-colors">
                                        수락
                                    </button>
                                </div>
                            </div>
                        }
                        {errorMessage &&
                            <div className="w-full text-center py-8 text-red-500 bg-red-100 border border-red-400 rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M12 2a10 10 0 110 20 10 10 0 010-20z" />
                                </svg>
                                {errorMessage}
                            </div>
                        }
                    </>)
                    : (
                        <LoadingComponent />
                    )}
            </div>
        </div>
    );
};

export default ApplyingRequestPopup;
